import StatDefault from './StatDefault'

export default StatDefault